import React from 'react';
import { monsterClassFromId } from '../../monsters';
import './City.scss';
import { useSelector, useDispatch } from 'react-redux';
import { selectRoomId, selectPlayerAtCityCenter, selectPlayerAtLake, selectIsLakeEnabled, selectPlayers } from '../../redux/gameSlice';
import { Trans } from '@lingui/macro';
import { selectCurrentAnimation } from '../../redux/animationSlice';
import { showGameBasicsAlert } from '../../redux/tutorialSlice';

export default function City() {
    const dispatch = useDispatch();
    const players = useSelector(selectPlayers);
    const playerIdAtCityCenter = useSelector(selectPlayerAtCityCenter);
    const playerIdAtLake = useSelector(selectPlayerAtLake);
    const playerAtCityCenter = players.find((player) => player.id === playerIdAtCityCenter);
    const playerAtLake = players.find((player) => player.id === playerIdAtLake);
    const usingLake = useSelector(selectIsLakeEnabled);
    const isPlayerAtLakeBeingDamaged = useSelector((state) => playerAtLake ? state.animation.playerBeingDamaged[playerAtLake.id] : false);
    const isPlayerAtCityCenterBeingDamaged = useSelector((state) => playerAtCityCenter ? state.animation.playerBeingDamaged[playerAtCityCenter.id] : false);
    const roomId = useSelector(selectRoomId);
    const curAnimation = useSelector(selectCurrentAnimation);
    const isPlayerAtCityStartingTurn = curAnimation && curAnimation.type === "player-starting-turn" && curAnimation.starting_at_city === true;
    const isPlayerAtLakeStartingTurn = curAnimation && curAnimation.type === "player-starting-turn" && curAnimation.starting_at_lake === true;
    const isPlayerEnteringCityCenter = curAnimation && curAnimation.type === "player-entering-town" && curAnimation.entering_city === true;
    const isPlayerEnteringLake = curAnimation && curAnimation.type === "player-entering-town" && curAnimation.entering_lake === true;

    let lakeMonsterClass = [];
    if (isPlayerEnteringLake) {
        lakeMonsterClass.push('monster-entering-town');
    }
    if (playerAtLake) {
        lakeMonsterClass.push(...["monster-in-city", monsterClassFromId(playerAtLake.monster_id)]);
    }
    if (isPlayerAtLakeBeingDamaged) {
        lakeMonsterClass.push("monster-damaged");
    }
    if (isPlayerAtLakeStartingTurn) {
        lakeMonsterClass.push("lake-monster-receiving-star");
    }

    let cityCenterMonsterClass = [];
    if (isPlayerEnteringCityCenter) {
        cityCenterMonsterClass.push('monster-entering-town');
    }
    if (playerAtCityCenter) {
        cityCenterMonsterClass.push(...["monster-in-city", monsterClassFromId(playerAtCityCenter.monster_id)]);
    }
    if (isPlayerAtCityCenterBeingDamaged) {
        cityCenterMonsterClass.push("monster-damaged");
    }
    if (isPlayerAtCityStartingTurn) {
        cityCenterMonsterClass.push("city-center-monster-receiving-star");
    }

    let lakeClosed = "";
    if (!usingLake) {
        lakeClosed = <div className="lake-closed">
            <span className="tooltip-wrap" aligned="top">
                <span className="tooltip">
                    <Trans>The Lake only becomes available when there are at least 5 players alive in the room!</Trans>
                </span>
            </span>
            <div className="lake-crack game-sprite"></div>
            <div className="closing-barrier game-sprite"></div>
        </div>;
    }

    return <div id="city-container" className="game-sprite">
        <div className='font-preload'>-</div>

        <div id="game-rules-container">
            <div id="game-rules-icon" className="game-sprite" onClick={() => dispatch(showGameBasicsAlert())}></div>
            <p><Trans>
                GAME RULES
            </Trans></p>
        </div>
        <div id="logo-game"></div>
        <div id="game-room-ID-container">
            <p className="game-room-ID-title"><Trans>
                GAME ROOM
            </Trans></p>
            <p className="game-room-ID">{roomId}</p>
        </div>
        <div id="the-amazing-pink-tree" className="game-sprite">
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div id="the-amazing-pink-tree-glow"></div>
        </div>
        <div id="enterprise-skyscrapper" className="game-sprite"></div>
        <div id="light-interaction-enterprise" className="light-interaction"></div>
        <div id="light-interaction-city" className="light-interaction"></div>
        <div id="light-interaction-car" className="light-interaction"></div>
        <div id="light-interaction-shop" className="light-interaction"></div>
        {lakeClosed}
        <div className={`game-sprite ${cityCenterMonsterClass.join(" ")}`} id="city-center-monster">
            {isPlayerEnteringCityCenter ? <div className="game-sprite star-earning-staying-town entering-town"></div> : null}
            {isPlayerAtCityStartingTurn ? <>
                <div className="game-sprite star-earning-staying-town"></div>
                <div className="game-sprite star-earning-staying-town second-star"></div>
            </> : null}
        </div>
        <div className={`game-sprite ${lakeMonsterClass.join(" ")}`} id="lake-monster">
            {isPlayerEnteringLake ? <div className="game-sprite star-earning-staying-town lake-version entering-town"></div> : null}
            {isPlayerAtLakeStartingTurn ? <>
                <div className="game-sprite star-earning-staying-town lake-version"></div>
                <div className="game-sprite star-earning-staying-town lake-version second-star"></div>
            </> : null}
        </div>
        <div id="five-players-sign">
            <span className="tooltip-wrap" aligned="top">
                <span className="tooltip">
                    <Trans>The Lake only becomes available when there are at least 5 players alive in the room!</Trans>
                </span>
            </span>
        </div>
    </div >
};
